import classNames from 'classnames'

export interface SelectOption {
  label: string
  value: string
}

export interface SelectProps {
  id: string
  label?: string
  defaultOptionLabel?: string
  className?: string
  name: string
  options: SelectOption[]
  register: any
  [key: string]: any
  variant?: 'primary' | 'secondary'
}

export const Select: React.FC<SelectProps> = ({
  label,
  defaultOptionLabel = null,
  id,
  name,
  register,
  options,
  className = '',
  variant = 'primary',
  ...rest
}) => {
  return (
    <div className={classNames('flex flex-col', className)}>
      {label && (
        <label htmlFor={id} className="pb-1 font-semibold">
          {label}
        </label>
      )}
      {/* eslint-disable-next-line jsx-a11y/no-onchange */}
      <select
        {...register(name)}
        id={id}
        className={classNames(
          variant === 'primary'
            ? 'placeholder-gray p-2 rounded-md  text-navy-900 border border-gray focus:outline-orange'
            : 'placeholder-gray focus:border-focused p-3 px-2 text-navy-900 bg-navy-light-50 border-0 focus:border-2 border-gray rounded focus:outline-none'
        )}
        {...rest}
      >
        {defaultOptionLabel && (
          <option disabled value="">
            {defaultOptionLabel}
          </option>
        )}
        {options.map((item) => (
          <option value={item.value} key={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  )
}
